import { ReactElement } from 'react';

import { MinuteInput } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../translations';
import { ReceptionServiceFormController } from '../ReceptionServiceForm';

export const DEFAULT_VALUE_ESTIMATED_DURATION = 30;

export type ReceptionServiceEstimatedDurationValue = number | null;

type ReceptionServiceEstimatedDurationFieldProps = Pick<ReceptionServiceFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const ReceptionServiceEstimatedDurationField = (
   props: ReceptionServiceEstimatedDurationFieldProps
): ReactElement => {
   return (
      <MinuteInput
         controller={props.register('estimatedDuration', { required: true })}
         testId={'estimatedDuration'}
         label={receptionServiceTranslationKeys.shared.form.components.estimatedDuration.label}
         disabled={props.disabled}
      />
   );
};
